import moment from 'moment';
import { apiRequest } from '../backend/vue-axios/axios';
// eslint-disable-next-line import/prefer-default-export
export const cachedAPIRequest = function request({
  module, service, pathparam, params, ttl = {},
}) {
  return new Promise((resolve, reject) => {
    const key = JSON.stringify({
      module, service, pathparam, params, ttl,
    });
    let value = sessionStorage.getItem(key);
    try {
      value = JSON.parse(value);
    } catch (e) {
      value = null;
    }
    if (value !== null) {
      if (value.ttl !== null) {
        const time = moment(value.ttl);
        const now = moment(new Date());
        if (now.isBefore(time)) {
          resolve(value);
        }
      }
    }
    apiRequest({
      module, service, pathparam, params,
    }).then((data) => {
      // eslint-disable-next-line no-param-reassign
      data.ttl = new Date();
      data.ttl.setMinutes(data.ttl.getMinutes() + 3);
      sessionStorage.setItem(key, JSON.stringify(data));
      resolve(data);
    }).catch((exception) => {
      reject(exception);
    });
  });
};
